import { Outlet } from "react-router-dom";
import "flowbite";
import useAxiosNavigation from "@hooks/useAxiosNavigation.js";
import Navbar from "../components/navigation/Navbar";
import Sidebar from "../components/navigation/Sidebar";

const MainLayout = ({ children }) => {
	// overflow-y-auto
	useAxiosNavigation();

	return (
		<div className="flex h-screen bg-dark-blue">
			<Navbar />
			<Sidebar />
			{/* className="flex flex-col flex-1 sm:ml-64 relative h-full" */}
			<div className="relative flex h-screen flex-1 flex-col sm:ml-64">
				{/* className="flex-1 w-full overflow-y-auto p-6 bg-gray-900 custom-scrollbar" */}
				<main className="custom-scrollbar relative w-full flex-1 overflow-y-auto bg-app-bg">
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default MainLayout;
